/*
 * Stub for react-native-image-crop-picker for webpack
 * so web builds don't fail
 */
export default { openCamera: () => {}, openPicker: () => {} }
const Image = {}
const Options = {}
export {
    Image,
    Options,
}